import {liteClient} from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import {searchBox, hits, configure, stats} from 'instantsearch.js/es/widgets';
import Ready from '../utils/ready';

Ready(() => {
    let timerId;
    const timeout = 150;
    if (!document.querySelector('#specialist-search-box')) return;

    const searchField = document.querySelector('#specialist-search-box');

    const searchClient = liteClient(
        '0JIZOCPQB1',
        'f446c9efada33fa663a7039c057f610c',
    );

    const searchIndex = 'dev_primary_index';
    const search = instantsearch({
        indexName: searchIndex,
        routing: false,
        searchClient,
        insights: true,
        onStateChange({uiState, setUiState}) {
            setUiState(uiState);
        },
        searchFunction(helper) {
            if (helper.state.query) {
                helper.search();
            }
        },
    });

    const searchPage = '/search/';

    function toggleHitsVisibility(container, isVisible) {
        if (isVisible) {
            document.querySelector(container).classList.remove('hidden');
        } else {
            document.querySelector(container).classList.add('hidden');
        }
    }

    const searchResultsClinician = (hit, {html}) => {
        if (hit.online_booking) {
            return html`<a
                href="${hit.url}"
                class="ais-search-result-link-wrapper ais-search-result-link-wrapper--clinician"
                data-insights-object-id="${hit.objectID}"
                data-insights-position="${hit.__position}"
                data-insights-query-id="${hit.__queryID}"
            >
                <div class="ais-search-result-body">
                    <h3>${hit.title}</h3>
                    <p class="ais-search-result-body__subtitle">
                        ${hit.expanded_content.job_title}
                    </p>
                    <p>${hit.excerpt}</p>
                </div>
                <div class="ais-search-result-image">
                    <img src="${hit.image}" />
                </div>
                <div class="ais-search-result-actions">
                    <a href="${hit.url}" class="btn btn-pill">View profile</a>
                    <a
                        href="/sulis-booking/book-clinician-appointment/${hit
                            .expanded_content.cc_id}/${hit.expanded_content
                            .first_specialist_unit_id}"
                        class="btn btn-pill btn-pill-gold book-button"
                        >Book online</a
                    >
                </div>
            </a>`;
        }
        if (hit.nhs_only) {
            return html`<a
                href="${hit.url}"
                class="ais-search-result-link-wrapper"
                data-insights-object-id="${hit.objectID}"
                data-insights-position="${hit.__position}"
                data-insights-query-id="${hit.__queryID}"
            >
                <div class="ais-search-result-body">
                    <h3>${hit.title}</h3>
                    <p class="ais-search-result-body__subtitle">
                        ${hit.expanded_content.job_title}
                    </p>
                    <p>${hit.excerpt}</p>
                </div>
                <div class="ais-search-result-image">
                    <img src="${hit.image}" />
                </div>
                <div class="ais-search-result-actions">
                    <p class="exclusively-nhs">
                        Exclusively NHS, no private practice
                    </p>
                    <a href="${hit.url}" class="btn btn-pill">View profile</a>
                </div>
            </a>`;
        }
        return html`<a
            href="${hit.url}"
            class="ais-search-result-link-wrapper"
            data-insights-object-id="${hit.objectID}"
            data-insights-position="${hit.__position}"
            data-insights-query-id="${hit.__queryID}"
        >
            <div class="ais-search-result-body">
                <h3>${hit.title}</h3>
                <p class="ais-search-result-body__subtitle">
                    ${hit.expanded_content.job_title}
                </p>
                <p>${hit.excerpt}</p>
            </div>
            <div class="ais-search-result-image">
                <img src="${hit.image}" />
            </div>
            <div class="ais-search-result-actions">
                <a href="${hit.url}" class="btn btn-pill">View profile</a>
            </div>
        </a>`;
    };

    search.addWidgets([
        configure({
            hitsPerPage: 200,
            filters: 'content_type:clinician',
            clickAnalytics: true,
        }),
        searchBox({
            container: searchField,
            reset: true,
            magnifier: true,
            placeholder: 'eg. surname, treatment, or condition',
            autofocus: searchPage,
            showReset: true,
            showSubmit: true,
            showLoadingIndicator: true,
            cssClasses: {
                root: 'ais-SearchBox',
                form: 'ais-SearchBox-form',
                input: 'ais-SearchBox-input fui-input',
                submit: 'ais-SearchBox-submit',
                reset: 'ais-SearchBox-reset',
                loadingIcon: 'ais-SearchBox-loading',
            },
            reset() {
                toggleHitsVisibility(
                    '#search-box--specialists__hits-clinicians',
                    0,
                );
            },
            queryHook(query, refine) {
                clearTimeout(timerId);
                timerId = setTimeout(() => refine(query), timeout);
                toggleHitsVisibility(
                    '#search-box--specialists__hits-clinicians',
                    query.length,
                );
            },
        }),
        stats({
            container: '#search-box--specialists__hits-clinicians-stats',
        }),
        hits({
            container: '#search-box--specialists__hits-clinicians',
            templates: {
                empty: 'No clinicians match your search',
                item: searchResultsClinician,
            },
            transformItems(items) {
                return items.sort((a, b) => {
                    // title is like "Dr Firstname Lastname", we want to sort by Lastname.
                    // If there are multiple last names, we take the first of them
                    const getThirdWord = (title) => {
                        if (!title) return '';
                        const words = title.trim().split(/\s+/);
                        return words.length > 2
                            ? words[2].toLowerCase()
                            : title.toLowerCase();
                    };
                    const nameA = getThirdWord(a.title);
                    const nameB = getThirdWord(b.title);
                    return nameA.localeCompare(nameB);
                });
            },
        }),
    ]);

    search.start();
    // search.refresh();

    // const searchBar = document.querySelector('.ais-SearchBox-input');

    // const specialists = document.querySelectorAll('.panel-specialist h3 a');

    // const specialistNames = Array.from(specialists).map(
    //     (name) => `eg. ${name.innerText.trim()}`,
    // );

    // const DELAY_AFTER_ANIMATION = 2000;
    // const MIN_ANIMATION_DELAY = 30;
    // const MAX_ANIMATION_DELAY = 120;
    // const treatmentExamples = [
    //     'Search...',
    //     'eg. knee surgeon',
    //     'eg. dermatologist',
    //     'eg. heart treatment',
    //     'eg. private GP',
    //     'eg. digestion doctor',
    //     'eg. gastro specialist',
    //     'eg. bladder problems',
    //     'eg. pain management',
    //     'eg. physiotherapy',
    //     'eg. asthma',
    //     'eg. ankle specialist',
    //     'eg. arthritis clinic',
    //     'eg. astigmatism test',
    //     'eg. back pain',
    //     'eg. ACL',
    //     'eg. Psoriasis',
    //     'eg. psychiatrist',
    //     'eg. orthopaedic surgeon',
    //     'eg. sports doctor',
    //     'eg. shoulder specialist',
    //     'eg. eye specialist',
    //     'eg. robotic assisted',
    //     'eg. robotic knee surgery',
    //     'eg. opthalmology',
    //     'eg. sports injury',
    //     'eg. hip replacement',
    //     'eg. general surgeon',
    //     'eg. ENT specialist',
    //     'eg. orthopaedic consultant',
    //     'eg. cardiologist',
    //     'eg. hypertension treatment',
    //     'eg. sigmoidoscopy',
    // ];

    // const PLACEHOLDERS = [...treatmentExamples, ...specialistNames];

    // const getRandomDelayBetween = (min, max) =>
    //     Math.floor(Math.random() * (max - min + 1) + min);

    // const setPlaceholder = (inputNode, placeholder) => {
    //     inputNode.setAttribute('placeholder', placeholder);
    // };

    // const animateLetters = (currentLetters, remainingLetters, inputNode) => {
    //     if (!remainingLetters.length) {
    //         return (
    //             typeof onAnimationEnd === 'function' &&
    //             onAnimationEnd(currentLetters.join(''), inputNode)
    //         );
    //     }

    //     currentLetters.push(remainingLetters.shift());

    //     setTimeout(
    //         () => {
    //             setPlaceholder(inputNode, currentLetters.join(''));
    //             animateLetters(currentLetters, remainingLetters, inputNode);
    //         },
    //         getRandomDelayBetween(MIN_ANIMATION_DELAY, MAX_ANIMATION_DELAY),
    //     );
    // };

    // const animatePlaceholder = (inputNode, placeholder) => {
    //     animateLetters([], placeholder.split(''), inputNode);
    // };

    // const onAnimationEnd = (placeholder, inputNode) => {
    //     setTimeout(() => {
    //         let newPlaceholder = '';

    //         do {
    //             newPlaceholder =
    //                 PLACEHOLDERS[
    //                     Math.floor(Math.random() * PLACEHOLDERS.length)
    //                 ];
    //         } while (placeholder === newPlaceholder);

    //         animatePlaceholder(inputNode, newPlaceholder, onAnimationEnd);
    //     }, DELAY_AFTER_ANIMATION);
    // };

    // window.addEventListener('load', () => {
    //     // If we want multiple, different placeholders, we pass our callback.
    //     animatePlaceholder(searchBar, PLACEHOLDERS[0], onAnimationEnd);
    // });
});
